<!-- Floating Button -->
<button class="floating-chat-btn" (click)="openChatBox()" *ngIf="!showChatBox" aria-label="Open chat">
    <mat-icon >chat</mat-icon>
</button>

<!-- Chat Box Window -->
<div class="chat-box" *ngIf="showChatBox">
    <button class="close-btn" (click)="closeChatBox()" aria-label="Close chat">&times;</button>
    <div #messageContainer class="messages">
        <div *ngFor="let msg of messages" class="message" [style.background-color]="getUserColor(msg.user.email)">
            <div class="message-user">
                <strong>{{ msg.user.username }}</strong>
                <span class="timestamp">{{ msg.timestamp }}</span>
            </div>
            <div class="message-text">{{ msg.message }}</div>
        </div>
        <div *ngIf="typingUsers.length > 0" class="typing">
            <ng-container *ngIf="typingUsers.length === 1">
                <em>{{ typingUsers[0] }} is typing...</em>
            </ng-container>
            <ng-container *ngIf="typingUsers.length > 1">
                <em>
                    {{ typingUsers.slice(0, -1).join(', ') + ' and ' + typingUsers.slice(-1) }} are typing...
                </em>
            </ng-container>
        </div>
    </div>
    <div class="input-area">
        <input
                type="text"
                [(ngModel)]="newMessage"
                (keydown)="onKeypress()"
                (keyup.enter)="sendMessage()"
                placeholder="Type a message..."
        />
        <button (click)="sendMessage()"><mat-icon >send</mat-icon></button>
    </div>
</div>
